import "../styles/components/ContactEntry.css";

type ContactEntryFields = {
  icon: string;
  title: string;
  content: string;
  link: string;
};

const ContactEntry: React.FC<ContactEntryFields> = ({
  icon,
  content,
  title,
  link,
}) => {
  return (
    <a className="contact" href={link} target="_blank" rel="noreferrer">
      <img alt='contact icon' className="contactIcon" src={icon} />
      <div className="contactText">
        <p className="contactTitle">
          <b> {title.toUpperCase()} </b>
        </p>
        <p className="contactDesc">
          {content}
        </p>
      </div>
    </a>
  );
};

export default ContactEntry;
